<template>
    <div>
        <v-dialog
        v-model="dialog"
        persistent
        width="300">
            <v-card
                color="dark"
                dark
            >
                <v-card-text>
                    Logout ...
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div> <!-- /.app-page logout-page -->
</template>

<script>
    import {mapActions} from "vuex";
    export default {
        data: () => ({
            dialog: false
        }),

        methods: {
            ...mapActions('auth', [
              'logout'
            ]),
        },

        mounted() {
            this.dialog = true

            this.logout().then(() => {
              // Set delay so that the route won't redirect back to
              // starting point.
              setTimeout(() => {
                window.location.href = '/';
                this.dialog = false
              }, 4000)
            });

        }, // End of Component > mounted

    } // End of export default
</script>

<style lang="scss" scoped>
    .logout-page,
    .logout-page > .app-display-flex {
        width: 100%; height: 100%;
    }

    .logout-page h1 {
        font-size: 24px;
        margin-top: 0;
        margin-bottom: 0;
    }

    .logout-page .preloader-container {
        text-align: center;

        ul, li {
            list-style: none;
            margin: 0;
            padding: 0;
            display: inline-block;
        }

        li {
            margin: 0 15px 15px;
        }

    }

</style>
